import AboutSpiceComponent from "../../components/about/about-spice";

const AboutSpicePage = () => <AboutSpiceComponent />

export default AboutSpicePage;
